<template>
  <template v-if="!loaded">
    <div class="p-5 rounded bg-body d-flex justify-content-between align-items-center mb-5">
      <h4 class="fw-bold text-gray-900 mb-0 ms-lg-4">
        {{ this.$route.meta.title || 'Страница' }}
        <span class="mt-2 d-block fw-normal fs-8 text-muted">{{ dTypes[type] }}</span>
      </h4>
      <div class="card-toolbar">
        <select-field
          v-model="type"
          id="client.sex"
          name="client_sex"
          :options="dTypes"
          placeholder="Тип"
        />
      </div>
    </div>
    <div class="p-3 rounded bg-body border">
      <div class="table-responsive">
        <table class="table border-bottom">
          <thead>
            <tr class="fw-bold fs-6 text-gray-800">
              <th v-for="(header, index) in sheetData[0]" :key="index">
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rowIndex) in sheetData.slice(1)" :key="rowIndex">
              <td v-for="(cell, cellIndex) in row" :key="cellIndex" class="border p-2">
                {{ cell }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>
  <loader v-else :height="90" text="Загрузка данных..."/>
</template>

<script>
  import Loader from '@/components/Loader'
  import axios from 'axios'
  import SelectField from '@/components/Fields/SelectField'

  export default {
    name: 'Analysis',
    components: {SelectField, Loader},
    data() {
      return {
        loaded: false,
        sheetData: [],
        type: 1,
        types: {
          1: 'pli=1&gid=313626942#gid=313626942',
          2: 'pli=1&gid=0#gid=0',
          3: 'pli=1&gid=1848439638#gid=1848439638',
          4: 'pli=1&gid=357703509#gid=357703509',
        },
        dTypes: {1: '1400 станции', 2: 'Цены', 3:'Количество станции', 4: 'Акции/описание'},
      }
    },
    mounted() {
      this.fetchSheetData()
    },
    methods: {
      async fetchSheetData() {
        const url = 'https://docs.google.com/spreadsheets/d/1F52JOTDtIHqdBz3HLJTxQNhxY0sCSf4AvNH9luxq9Zo/gviz/tq?tqx=out:json?'+this.types[this.type]
        this.loaded = true
        try {
          const response = await axios.get(url)
          const rawText = response.data
          const json = JSON.parse(rawText.substr(47).slice(0, -2))
          const rows = json.table.rows
          this.sheetData = rows.map(row => row.c.map(cell => (cell ? cell.v : '')))
        } catch (error) {
          console.error('Ошибка при загрузке данных:', error)
        } finally {
          this.loaded = false
        }
      }
    },
    watch: {
      type: {
        deep: true,
        handler(val) {
          if (val) this.fetchSheetData()
        }
      }
    }
  }
</script>
<style scoped>
</style>